import { render, staticRenderFns } from "./InboxPluginSession.vue?vue&type=template&id=4af383af"
import script from "./InboxPluginSession.vue?vue&type=script&lang=js"
export * from "./InboxPluginSession.vue?vue&type=script&lang=js"
import style0 from "./InboxPluginSession.vue?vue&type=style&index=0&id=4af383af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports